'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = listenForReduxFormSubmit;

var _effects = require('redux-saga/effects');

var _reduxSaga = require('redux-saga');

var _reduxForm = require('redux-form');

var _reduxFormSubmitActions = require('actions/reduxFormSubmitActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(dispatchSubmitAction),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(formSubmitSaga),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(listenForReduxFormSubmit); // Thieved from https://github.com/yelouafi/redux-saga/issues/161#issuecomment-229350795
//
// A redux-form form uses onSubmitActions (reduxFormSubmitActions.js) to provide 3 actions:
//  - submitAction for the form to dispatch on submit
//  - sucessAction for formSubmitSaga to listen for if the form submit should succeed,
//  - failureAction for formSubmitSaga to listen for if the form submit should fail
//
// The form is then returned a promise (which redux-form expects for server-side validation) that
//  either gets resolved or rejected if the successAction or failureAction are dispatched respectively
//  (from listenForReduxFormSubmit and formSubmitSaga (listenForReduxFormSubmit.js) which
//  listen for these actions in submitAction then successAction/failureAction flow order)

function dispatchSubmitAction(submitAction, values) {
    return _regenerator2.default.wrap(function dispatchSubmitAction$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.put)({ type: submitAction, payload: (0, _extends3.default)({}, values) });

                case 2:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function formSubmitSaga(_ref) {
    var payload = _ref.payload;

    var submitAction, successAction, failureAction, values, resolve, reject, _ref2, success, failure;

    return _regenerator2.default.wrap(function formSubmitSaga$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    submitAction = payload.submitAction, successAction = payload.successAction, failureAction = payload.failureAction, values = payload.values, resolve = payload.resolve, reject = payload.reject;

                    // We don't want this to block in case we miss the success/failure action, so we fork

                    _context2.next = 3;
                    return (0, _effects.fork)(dispatchSubmitAction, submitAction, values);

                case 3:
                    _context2.next = 5;
                    return (0, _effects.race)({
                        success: (0, _effects.take)(successAction),
                        failure: (0, _effects.take)(failureAction)
                    });

                case 5:
                    _ref2 = _context2.sent;
                    success = _ref2.success;
                    failure = _ref2.failure;


                    if (success) {
                        resolve();
                    } else {
                        reject(new _reduxForm.SubmissionError(failure.errors));
                    }

                case 9:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function listenForReduxFormSubmit() {
    return _regenerator2.default.wrap(function listenForReduxFormSubmit$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    return _context3.delegateYield((0, _reduxSaga.takeEvery)(_reduxFormSubmitActions.FORM_SUBMIT, formSubmitSaga), 't0', 1);

                case 1:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/sagas/listenForReduxFormSubmit.js
// module id = 1420
// module chunks = 0